module.exports = __webpack_public_path__ + "img/PORT02.acd166a9.jpg";